import { useCallback, useRef, useState } from "react";
const NO_PENDING_FAVORITES = new Map();
export const readPendingFavorite = ({ pendingFavorites, characterId, }) => {
    if (characterId === null || !pendingFavorites.has(characterId)) {
        return null;
    }
    return pendingFavorites.get(characterId) === true;
};
/** Pending toggles are keyed by chatbot so a second card or overlay mid-request neither locks the other nor drops the first one. */
export default function useOptimisticFavorite({ likedBots, onFavorite }) {
    const [statePendingFavorites, setStatePendingFavorites] = useState(NO_PENDING_FAVORITES);
    const refPendingFavorites = useRef(statePendingFavorites);
    refPendingFavorites.current = statePendingFavorites;
    const clearPendingFavorite = useCallback((characterId) => {
        const remainingFavorites = new Map(refPendingFavorites.current);
        remainingFavorites.delete(characterId);
        refPendingFavorites.current = remainingFavorites;
        setStatePendingFavorites(remainingFavorites);
    }, []);
    // Lock before the request so a second tap in the same turn cannot start another toggle.
    const toggleFavorite = useCallback((selectedId) => {
        if (refPendingFavorites.current.has(selectedId)) {
            return;
        }
        const nextPendingFavorites = new Map(refPendingFavorites.current).set(selectedId, !likedBots.includes(selectedId));
        refPendingFavorites.current = nextPendingFavorites;
        setStatePendingFavorites(nextPendingFavorites);
        const request = onFavorite(selectedId);
        const settleFavorite = () => clearPendingFavorite(selectedId);
        if (!(request instanceof Promise)) {
            settleFavorite();
            return;
        }
        void request.then(settleFavorite, settleFavorite);
    }, [clearPendingFavorite, likedBots, onFavorite]);
    return { pendingFavorites: statePendingFavorites, toggleFavorite };
}
